import {
  RESIDENTIAL_PROGRAM_TYPE_LABELS,
  SCHOOL_PROGRAM_TYPE_LABELS,
} from '@shared/models/design/activities/properties';
import { ActivityType } from '@shared/models/design/activities/activity-type.model';

export type ActivityPropertySelectOption = {
  value: string;
  label: string;
};

export type ActivityPropertyFieldConfig =
  | { kind: 'number' }
  | { kind: 'select'; label: string; options: ActivityPropertySelectOption[] };

const optionsFrom = (
  labels: Record<string, string>,
): ActivityPropertySelectOption[] =>
  Object.entries(labels).map(([value, label]) => ({ value, label }));

const RESIDENTIAL_TYPE_OPTIONS = optionsFrom(RESIDENTIAL_PROGRAM_TYPE_LABELS);

const SCHOOL_TYPE_OPTIONS = optionsFrom(SCHOOL_PROGRAM_TYPE_LABELS);

const ACTIVITY_PROPERTY_FIELDS: Partial<
  Record<ActivityType, Record<string, ActivityPropertyFieldConfig>>
> = {
  [ActivityType.Residential]: {
    program_type: {
      kind: 'select',
      label: 'Type',
      options: RESIDENTIAL_TYPE_OPTIONS,
    },
  },
  [ActivityType.School]: {
    program_type: {
      kind: 'select',
      label: 'Type',
      options: SCHOOL_TYPE_OPTIONS,
    },
  },
};

/**
 * Field config for an activity property key, if specialized.
 */
export const getActivityPropertyFieldConfig = (
  activityType: ActivityType,
  propertyKey: string,
): ActivityPropertyFieldConfig | undefined =>
  ACTIVITY_PROPERTY_FIELDS[activityType]?.[propertyKey];
